import * as React from "react";
import { useApplicationList, ContentPage } from "./store";
import { ListView } from "./listView";
import { DetailView } from "./detailView";
import { EditView } from "./editView";

interface Props {
    clubID: number;
}

const ClubMemberApplications = ({ clubID }: Props) => {
    let [state, actions] = useApplicationList();

    actions.setClubID(clubID);

    const showList = state.page == ContentPage.List;
    const showDetail = state.page == ContentPage.Detail;
    const showEdit = state.page == ContentPage.Edit;

    return <div>
        {showList && <ListView />}
        {showDetail && <DetailView />}
        {showEdit && <EditView />}
    </div>;
}

export {
    ClubMemberApplications
}